var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "custom-modal",
      attrs: {
        name: "patientDetailModal",
        width: "605px",
        height: "auto",
        scrollable: true,
        clickToClose: false
      },
      on: { "before-open": _vm.beforeOpen, "before-close": _vm.beforeClose }
    },
    [
      _c("div", { staticClass: "modal-padding" }, [
        _c(
          "div",
          {
            staticClass: "modal-close-img",
            on: {
              click: function($event) {
                _vm.hideModal()
              }
            }
          },
          [_c("div", { staticClass: "icon-close" })]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "title" }, [_vm._v("details")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "text" }, [
              _vm._v(
                "Name: " +
                  _vm._s(_vm.patientDetail.firstName) +
                  " " +
                  _vm._s(_vm.patientDetail.lastName)
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text" }, [
              _vm._v("Email address: " + _vm._s(_vm.patientDetail.email))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text" }, [
              _vm._v("Employer ID: " + _vm._s(_vm.patientDetail.employerId))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text" }, [
              _vm._v("Signed up: " + _vm._s(_vm.patientDetail.signedUpAt))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text" }, [
              _vm._v("Email reminders sent:")
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0687cf26", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0687cf26","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/patient/PatientDetailModal.vue
// module id = 1616
// module chunks = 1